import { Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageLayout } from '@hero/components/layouts';
import { configs } from '@hero/configs';
import { CompanyLogo, DigitalWrapper, SettingsTabs } from '@hero/organisms';

import * as S from './style';

export default function BrandingPage() {
  const { t } = useTranslation();

  return (
    <PageLayout
      header={{
        title: t('settings')
      }}
    >
      <SettingsTabs />
      <S.Branding>
        <S.BrandingCard>
          <CompanyLogo />
        </S.BrandingCard>
        {configs?.advanceSettings?.digitalWrapperEnabled && (
          <S.BrandingCard>
            <S.TitleWrapper>
              <Typography variant="body1Bold">{t('digitalWrapper')}</Typography>
            </S.TitleWrapper>
            <DigitalWrapper isUpdateBrandingLibrary />
          </S.BrandingCard>
        )}
      </S.Branding>
    </PageLayout>
  );
}
